function timeStringToMilliseconds(timeStr: string): number {
    const [hours, minutes, seconds] = timeStr.split(':').map(Number);
    return ((hours * 60 + minutes) * 60 + seconds) * 1000;
}

// ----------------------------------------------------------------------------

export default timeStringToMilliseconds;
